import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import MainButton from "../../Buttons/MainButton";
import Input from "../../Inputs/Input";
import Selected from "../../Inputs/Selected";
import Title from "../../Title/Title";

export default function Graduation_Decision() {
  return (
    <>
      <Row>
        <Col>
          <Title title="اصدار قرار التخرج  " />
        </Col>
      </Row>

      <Row justify={"around"}>
        <Col lg={5} md={5} sm={11}>
          <Input placeholder=" الرقم الامتحاني " />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input placeholder="الاسم" />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input placeholder=" النسبة" />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input placeholder="اسم الاب" />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input placeholder="اسم الام" />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input placeholder=" مكان الميلاد" />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input placeholder="محل ورقم القيد" />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input placeholder="الرقم الوطني" />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Selected
            title="  المحافظة "
            value={""}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
              // handleChangeInput(e);
              // setSelectedOptionType(e.target.options[e.target.selectedIndex].dataset.type)
            }}
          >
            <option>دمشق</option>
            <option>حمص</option>
            <option>حماة</option>
            <option>حلب</option>
          </Selected>
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input placeholder=" شعبة التجنيد" />
        </Col>

        <Col lg={5} md={5} sm={11}>
          <Selected
            title="  الجنس "
            value={""}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
              // handleChangeInput(e);
              // setSelectedOptionType(e.target.options[e.target.selectedIndex].dataset.type)
            }}
          >
            <option>ذكر</option>
            <option>انثى</option>
          </Selected>
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input placeholder="الجنسية " />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input placeholder="الثانوية " />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input placeholder="عام التسجيل " />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input placeholder="المعدل " />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input placeholder="التقدير " />
        </Col>
      </Row>

      <Row>
        <Col
          lg={11}
          md={5}
          sm={11}
          className="flex lg:justify-end max-lg:mx-auto  !mt-4 "
        >
          <MainButton titlebtn="اصدار" className="w-[400px]" />
        </Col>
      </Row>
    </>
  );
}
